export default __webpack_public_path__ + "static/media/erss.d5b2c975.svg";